import React, { useContext, useState } from "react";

import _ from "lodash";
import { Icon } from "@iconify/react/dist/iconify.js";

import { CURSOS_DATA } from "../data/cursos";

import { store } from "../../../components/Store";
import { ReadFlag } from "../components/read-flag";
import { PlanCard } from "../components/plan-card";
import { useTranslations } from "../../../hooks/use-translations";
import { useWindowOpen } from "../../../hooks/useWindowOpen";
import ReactPixel from 'react-facebook-pixel';
import { usePaymentHandler } from "../../hooks/use-payment-handler";
import { useLanguage } from "../../../hooks/use-language";

/**
 * Componente que renderiza la sección de "Aprender algo nuevo" en el plan casa
 * @returns {JSX.Element} AprenderMakeMake
 */
export const AprenderMakeMake = () => {
    const lang = useLanguage();
    const textosAcademia = useTranslations({ section: "academia", lang: lang });
    const textosTienda = useTranslations({ section: "tienda_makemake", lang: lang });

    const courses = CURSOS_DATA;
    const paymentHandler = usePaymentHandler();
    const globalState = useContext(store);
    const { state } = globalState;
    const { pais } = state;

    const [loading, setLoading] = useState({
       "tiempo-irrepetible": false,
        "leer-la-web": false,
        "ilustracion-botanica": false
    });

    const newWindowTab = useWindowOpen();

    return (
        <>
            <ReadFlag title={textosTienda?.tabpanel?.aprender || "Aprender algo nuevo"} />

            <div className="d-flex flex-nowrap justify-content-center align-items-center mt-4">
                <p className="flex-grow secondary-inverse--color secondary-font text-16 font-weight-bold">
                    {textosTienda?.tienda?.casa?.subtitulo2 ||  "Educación complementaria para cualquier persona en cualquier lugar."}
                </p>
                <div className="flex-grow-1 secondary-inverse--bg ml-4" style={{ height: 2 }}></div>
            </div>

            <div className="col-xl-10 mx-auto px-0 mt-4">
                {courses.map((curso, index) => {
                    const finalPrice = curso?.precio?.usd || 'n/a';
                    const moneda = 'USD';
                    const isOffer = curso?.descuento?.activado;
                    const offer = curso?.descuento?.usd || 'n/a';
                    const isPreSale = curso?.preventa?.activado;
                    const idCurso = curso?.id; 

                    return (
                        <PlanCard.box key={`curso-${index}`}>
                            <PlanCard.columnLeft
                                className={curso?.className}
                                image={curso?.imgUrl}
                            >
                                <div
                                    className="card-description"
                                    tabIndex={0}
                                    aria-label={'descripción del curso'}
                                >
                                    <div>
                                        <p className="general-description">{_.get(textosAcademia, curso?.descripcion?.translationPath) || curso?.descripcion?.default}</p>
                                        <h4>{_.get(textosAcademia, curso?.nombre?.translationPath) || curso?.nombre?.default || 'N/A'}</h4>
                                        <p
                                            className="creator"
                                            dangerouslySetInnerHTML={{ __html: _.get(textosAcademia, curso?.autor?.translationPath) || curso?.autor?.default || 'N/A' }}
                                        ></p>
                                    </div>
                                </div>
                            </PlanCard.columnLeft>

                            <PlanCard.columnRight className={'column-right'}>
                                <PlanCard.details>
                                    <>
                                        <ul className="features-list mb-4 mb-lg-0 mt-lg-4">
                                            {curso.detalles.map((element, i) => {
                                                return (
                                                    <li key={`element-${i}`} dangerouslySetInnerHTML={{ __html: _.get(textosAcademia, element?.translationPath) || element?.default || 'N/A' }}></li>
                                                )
                                            })}
                                        </ul>
                                        {curso?.extraInformation?.activado &&
                                            <>
                                                <p
                                                    className="red-inverse--color font-weight-bold"
                                                    dangerouslySetInnerHTML={{ __html: _.get(textosAcademia, curso?.extraInformation?.titulo?.translationPath) || curso?.extraInformation?.titulo?.default || 'N/A' }}
                                                ></p>

                                                <ul className="features-list mb-4">
                                                    {curso.extraInformation.detalles.map((element, i) => {
                                                        return (
                                                            <li key={`element-${i}`} dangerouslySetInnerHTML={{ __html: _.get(textosAcademia, element?.translationPath) || element?.default || 'N/A' }}></li>
                                                        )
                                                    })}
                                                </ul>
                                            </>
                                        }
                                    </>
                                </PlanCard.details>
                                <PlanCard.PriceDescription
									discount={curso?.descuento}
									price={curso?.precio}
									academySlot={
										<div className="w-100 px-2">
											<p className="font-weight-bold onprimary--color">
												{textosAcademia?.interfaz?.precio ||
													"Precio por persona"}
											</p>
											{isPreSale && (
												<p
													className="red-inverse--color font-weight-bold text-14"
													dangerouslySetInnerHTML={{
														__html:
															_.get(
																textosAcademia,
																curso?.preventa?.text
																	?.translationPath,
															) ||
															curso?.preventa?.text?.default ||
															"N/A",
													}}
												></p>
											)}
										</div>
									}
								></PlanCard.PriceDescription>

                                <PlanCard.getButtons>
                                    <button
                                        className="btn-trailer mr-3 focusable-red"
                                        onClick={() => {
                                            ReactPixel.trackCustom('DescripcionCurso', {name:curso?.nombre?.default})
                                            newWindowTab.open('_blank', curso?.trailer)
                                        }}
                                    >
                                        <i className="fas fa-play mx-auto"></i>
                                        <p>{textosAcademia?.interfaz?.trailer || 'Ver trailer'}</p>
                                    </button>

                                    <button
                                        className="btn-tarjeta-plan focusable-red"
                                        onClick={() => {
                                            ReactPixel.trackCustom('CompraCurso', {name:curso?.nombre?.default})
                                            paymentHandler.openPaymentPage({data:curso});
                                        }}
                                    >
                                        {textosAcademia?.interfaz?.btn_comprar || 'Comprar'}  {' '}
                                        {loading?.[idCurso]  && <Icon icon="fa:spinner" className={'spinner-rotation'} />}
                                    </button>
                                </PlanCard.getButtons>
                            </PlanCard.columnRight>

                        </PlanCard.box>
                    )
                })}
            </div>
        </>
    )
}

